module.exports = __webpack_public_path__ + "img/time_turner.087897be.jpg";